{
  "v": "4.8.0",
  "meta": { "g": "LottieFiles AE 3.0.2", "a": "", "k": "", "d": "", "tc": "" },
  "fr": 25,
  "ip": 0,
  "op": 90,
  "w": 1080,
  "h": 1080,
  "nm": "Loading_2",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Layer 2 Outlines",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 79,
              "s": [0]
            },
            { "t": 89, "s": [180] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [539.116, 539.958, 0], "ix": 2 },
        "a": { "a": 0, "k": [255.19, 423.539, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [-0.041, -38.592],
                    [-30.712, -26.446],
                    [-18.599, -16.42],
                    [28.674, -25.244],
                    [18.945, -16.443],
                    [0.168, -39.704],
                    [0, -31.975],
                    [0, 0],
                    [0, 0],
                    [-0.007, 2.704],
                    [-0.055, 38.591],
                    [30.958, 26.612],
                    [18.572, 16.449],
                    [-28.25, 24.903],
                    [-18.806, 16.182],
                    [0.036, 40.69],
                    [0.008, 38.316],
                    [10.748, 0],
                    [110.834, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 38.592],
                    [0.043, 40.351],
                    [18.8, 16.188],
                    [28.667, 25.309],
                    [-18.828, 16.576],
                    [-30.12, 26.141],
                    [-0.135, 31.975],
                    [0, 0],
                    [0, 0],
                    [0.153, -3.332],
                    [0.096, -38.591],
                    [0.057, -40.694],
                    [-18.814, -16.172],
                    [-28.225, -25],
                    [18.611, -16.407],
                    [30.947, -26.629],
                    [-0.034, -38.317],
                    [-0.003, -10.693],
                    [-110.834, -0.003],
                    [0, 0]
                  ],
                  "v": [
                    [-176.333, -318.143],
                    [-176.333, -307.781],
                    [-176.323, -192.005],
                    [-130.603, -91.676],
                    [-74.581, -42.674],
                    [-74.62, 42.364],
                    [-131.242, 91.936],
                    [-176.304, 190.895],
                    [-176.331, 286.823],
                    [-176.331, 316.565],
                    [177.436, 316.565],
                    [177.822, 307.826],
                    [178.052, 192.054],
                    [131.974, 91.046],
                    [75.955, 42.041],
                    [76.035, -42.442],
                    [132.061, -91.44],
                    [178.063, -192.486],
                    [178.054, -307.435],
                    [167.285, -318.141],
                    [-165.216, -318.143]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [7.941, 6.082],
                    [-32.31, 17.561],
                    [0.062, 7.137],
                    [0.305, 38.31],
                    [-40.869, 34.69],
                    [-17.388, 15.289],
                    [14.421, 12.673],
                    [18.481, 16.132],
                    [0.146, 50.462],
                    [-0.079, 40.518],
                    [4.681, 2.492],
                    [-5.665, 23.049],
                    [-27.596, 0.089],
                    [-56.239, 0],
                    [-70.574, -0.034],
                    [-10.948, -19.125],
                    [26.372, -14.001],
                    [-0.047, -6.288],
                    [-0.362, -38.584],
                    [41.15, -34.859],
                    [17.569, -15.499],
                    [-13.751, -12.089],
                    [-18.507, -16.102],
                    [-0.096, -50.787],
                    [0.068, -40.517],
                    [-4.363, -2.371],
                    [3.583, -22.396],
                    [20.025, -1.908],
                    [0.957, -0.498]
                  ],
                  "o": [
                    [-9.433, -4.135],
                    [-29.203, -22.366],
                    [6.688, -3.636],
                    [-0.334, -38.311],
                    [-0.423, -53.364],
                    [17.65, -14.981],
                    [14.602, -12.84],
                    [-18.426, -16.195],
                    [-38.203, -33.346],
                    [-0.118, -40.517],
                    [0.009, -4.363],
                    [-23.229, -12.363],
                    [6.243, -25.405],
                    [56.238, -0.183],
                    [70.573, -0.001],
                    [21.297, 0.01],
                    [14.818, 25.886],
                    [-5.784, 3.07],
                    [0.292, 38.586],
                    [0.505, 53.686],
                    [-17.875, 15.141],
                    [-13.611, 12.008],
                    [18.424, 16.197],
                    [38.491, 33.49],
                    [0.076, 40.517],
                    [-0.007, 4.046],
                    [22.457, 12.2],
                    [-4.067, 25.42],
                    [-0.995, 0.094],
                    [0, 0]
                  ],
                  "v": [
                    [-197.664, 423.289],
                    [-225.737, 410.59],
                    [-218.775, 325.23],
                    [-210.299, 310.637],
                    [-210.517, 195.7],
                    [-150.757, 63.443],
                    [-98.442, 17.752],
                    [-98.196, -17.853],
                    [-153.575, -66.323],
                    [-210.433, -192.381],
                    [-210.411, -313.935],
                    [-215.627, -323.74],
                    [-244.075, -382.059],
                    [-190.184, -423.106],
                    [-21.468, -423.163],
                    [190.254, -423.15],
                    [240.122, -396.592],
                    [219.503, -324.97],
                    [212.034, -312.28],
                    [212.251, -196.517],
                    [152.239, -63.539],
                    [99.304, -17.302],
                    [99.544, 17.207],
                    [154.934, 65.665],
                    [212.165, 192.392],
                    [212.14, 313.945],
                    [216.919, 323.172],
                    [246.646, 378.037],
                    [202.263, 421.846],
                    [199.388, 423.289]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.270999983245, 0.352999997606, 0.39199999641, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [255.19, 423.539], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 90,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Layer 3 Outlines",
      "parent": 1,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [253.816, 647.172, 0], "ix": 2 },
        "a": { "a": 0, "k": [204.08, 133.594, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "hasMask": true,
      "masksProperties": [
        {
          "inv": false,
          "mode": "a",
          "pt": {
            "a": 0,
            "k": {
              "i": [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0]
              ],
              "o": [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0]
              ],
              "v": [
                [400.511, -56.996],
                [14.911, -56.996],
                [15.806, 269.507],
                [401.405, 269.507]
              ],
              "c": true
            },
            "ix": 1
          },
          "o": { "a": 0, "k": 100, "ix": 3 },
          "x": { "a": 0, "k": 0, "ix": 4 },
          "nm": "Mask 1"
        }
      ],
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.9 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [10.651, -12.171],
                          [51.43, -58.589],
                          [-7.713, -20.164],
                          [-16.771, 0.129],
                          [-52.308, -0.001],
                          [-52.823, -0.367],
                          [-7.294, 19.048],
                          [12.106, 13.836],
                          [51.355, 58.68],
                          [9.373, -0.001]
                        ],
                        "o": [
                          [-51.355, 58.679],
                          [-12.245, 13.948],
                          [7.328, 19.16],
                          [52.305, -0.403],
                          [52.825, 0],
                          [16.792, 0.116],
                          [7.743, -20.218],
                          [-51.349, -58.685],
                          [-10.488, -11.985],
                          [-9.447, 0.001]
                        ],
                        "v": [
                          [-29.508, 113.916],
                          [-183.412, 290.133],
                          [-196.117, 339.137],
                          [-157.715, 362.216],
                          [-0.792, 362.068],
                          [157.682, 362.203],
                          [196.086, 338.953],
                          [183.117, 289.919],
                          [29.271, 113.631],
                          [0.055, 95.657]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.9 },
                    "o": { "x": 0.167, "y": 0.1 },
                    "t": 67,
                    "s": [
                      {
                        "i": [
                          [10.651, -12.171],
                          [51.43, -58.589],
                          [-7.713, -20.164],
                          [-16.771, 0.129],
                          [-52.308, -0.001],
                          [-52.823, -0.367],
                          [-7.294, 19.048],
                          [12.106, 13.836],
                          [51.355, 58.68],
                          [9.373, -0.001]
                        ],
                        "o": [
                          [-51.355, 58.679],
                          [-12.245, 13.948],
                          [7.328, 19.16],
                          [52.305, -0.403],
                          [52.825, 0],
                          [16.792, 0.116],
                          [7.743, -20.218],
                          [-51.349, -58.685],
                          [-10.488, -11.985],
                          [-9.447, 0.001]
                        ],
                        "v": [
                          [-29.508, -138.413],
                          [-183.412, 37.805],
                          [-196.117, 86.808],
                          [-157.715, 109.887],
                          [-0.792, 109.739],
                          [157.682, 109.875],
                          [196.086, 86.625],
                          [183.117, 37.591],
                          [29.271, -138.698],
                          [0.055, -156.672]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0.1 },
                    "t": 72,
                    "s": [
                      {
                        "i": [
                          [10.651, -12.171],
                          [51.43, -58.589],
                          [-7.713, -20.164],
                          [-16.771, 0.129],
                          [-52.308, -0.001],
                          [-52.823, -0.367],
                          [-7.294, 19.048],
                          [12.106, 13.836],
                          [51.355, 58.68],
                          [9.373, -0.001]
                        ],
                        "o": [
                          [-51.355, 58.679],
                          [-12.245, 13.948],
                          [7.328, 19.16],
                          [52.305, -0.403],
                          [52.825, 0],
                          [16.792, 0.116],
                          [7.743, -20.218],
                          [-51.349, -58.685],
                          [-10.488, -11.985],
                          [-9.447, 0.001]
                        ],
                        "v": [
                          [-29.008, -153.389],
                          [-183.412, 34.829],
                          [-196.117, 83.832],
                          [-157.715, 106.911],
                          [-0.792, 106.763],
                          [157.682, 106.899],
                          [196.086, 83.649],
                          [183.117, 34.615],
                          [29.771, -153.674],
                          [0.555, -171.648]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [10.651, -12.171],
                          [51.43, -58.589],
                          [-7.713, -20.164],
                          [-16.771, 0.129],
                          [-52.308, -0.001],
                          [-52.823, -0.367],
                          [-7.294, 19.048],
                          [12.106, 13.836],
                          [51.355, 58.68],
                          [9.373, -0.001]
                        ],
                        "o": [
                          [-51.355, 58.679],
                          [-12.245, 13.948],
                          [7.328, 19.16],
                          [52.305, -0.403],
                          [52.825, 0],
                          [16.792, 0.116],
                          [7.743, -20.218],
                          [-51.349, -58.685],
                          [-10.488, -11.985],
                          [-9.447, 0.001]
                        ],
                        "v": [
                          [-29.508, -143.084],
                          [-183.412, 33.133],
                          [-196.117, 82.137],
                          [-157.715, 105.215],
                          [-0.792, 105.067],
                          [157.682, 105.204],
                          [196.086, 81.954],
                          [183.117, 32.919],
                          [29.271, -143.369],
                          [0.055, -161.343]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "gf",
              "o": { "a": 0, "k": 100, "ix": 10 },
              "r": 1,
              "bm": 0,
              "g": {
                "p": 3,
                "k": {
                  "a": 0,
                  "k": [
                    0.243, 0.149, 0.922, 0.639, 0.43, 0.075, 0.782, 0.802,
                    0.677, 0, 0.643, 0.965
                  ],
                  "ix": 9
                }
              },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 0,
                    "s": [0.56, 1024.846],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 77, "s": [0.56, 189.82] }
                ],
                "ix": 5
              },
              "e": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 0,
                    "s": [-0.62, -270.102],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 77, "s": [-0.62, -270.102] }
                ],
                "ix": 6
              },
              "t": 1,
              "nm": "Gradient Fill 1",
              "mn": "ADBE Vector Graphic - G-Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [204.08, 133.594], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 90,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Layer 3 Outlines 2",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 180, "ix": 10 },
        "p": { "a": 0, "k": [535.7, 355.278, 0], "ix": 2 },
        "a": { "a": 0, "k": [204.037, 362.532, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [10.651, -12.171],
                          [51.43, -58.589],
                          [-7.713, -20.164],
                          [-16.771, 0.129],
                          [-52.308, -0.001],
                          [-52.823, -0.367],
                          [-7.294, 19.048],
                          [12.106, 13.836],
                          [51.355, 58.68],
                          [9.373, -0.001]
                        ],
                        "o": [
                          [-51.355, 58.679],
                          [-12.245, 13.948],
                          [7.328, 19.16],
                          [52.305, -0.403],
                          [52.825, 0],
                          [16.792, 0.116],
                          [7.743, -20.218],
                          [-51.349, -58.685],
                          [-10.488, -11.985],
                          [-9.447, 0.001]
                        ],
                        "v": [
                          [-29.508, 113.916],
                          [-183.412, 290.133],
                          [-196.117, 339.137],
                          [-157.715, 362.216],
                          [-0.792, 362.068],
                          [157.682, 362.203],
                          [196.086, 338.953],
                          [183.117, 289.919],
                          [29.271, 113.631],
                          [0.055, 95.657]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 5,
                    "s": [
                      {
                        "i": [
                          [8.413, -12.171],
                          [40.626, -58.587],
                          [-6.092, -20.164],
                          [-13.247, 0.129],
                          [-41.317, 0],
                          [-41.724, -0.365],
                          [-5.762, 19.048],
                          [9.562, 13.836],
                          [40.562, 58.682],
                          [7.404, -0.001]
                        ],
                        "o": [
                          [-40.564, 58.679],
                          [-9.672, 13.948],
                          [5.788, 19.16],
                          [41.314, -0.403],
                          [41.725, 0],
                          [13.264, 0.116],
                          [6.116, -20.218],
                          [-40.559, -58.685],
                          [-8.284, -11.985],
                          [-7.462, 0.001]
                        ],
                        "v": [
                          [-29.148, 11.044],
                          [-187.596, 188.113],
                          [-197.632, 237.116],
                          [-167.3, 260.195],
                          [-5.969, 260.068],
                          [156.587, 260.224],
                          [186.922, 236.974],
                          [176.677, 187.94],
                          [18.706, 11.064],
                          [-2.835, -272.344]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 56,
                    "s": [
                      {
                        "i": [
                          [2.282, -2.551],
                          [4.363, -11.584],
                          [-1.652, -4.227],
                          [-3.593, 0.027],
                          [-11.206, 0],
                          [-11.316, -0.077],
                          [-1.563, 3.993],
                          [1.296, 3.546],
                          [11.521, 14.522],
                          [2.008, 0]
                        ],
                        "o": [
                          [-11.002, 12.3],
                          [-0.884, 3.546],
                          [1.57, 4.016],
                          [11.205, -0.084],
                          [11.317, 0],
                          [3.597, 0.024],
                          [1.659, -4.238],
                          [-5.376, -12.299],
                          [-2.091, -2.675],
                          [-2.024, 0]
                        ],
                        "v": [
                          [-29.128, 11.314],
                          [-47.116, 52.477],
                          [-46.575, 61.447],
                          [-38.348, 66.285],
                          [-4.731, 66.254],
                          [29.219, 66.282],
                          [37.446, 61.409],
                          [37.93, 49.719],
                          [18.443, 11.288],
                          [-2.052, -87.547]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 62,
                    "s": [
                      {
                        "i": [
                          [1.387, -1.148],
                          [-0.926, -4.728],
                          [-1.005, -1.902],
                          [-2.185, 0.012],
                          [-6.813, 0],
                          [-6.881, -0.034],
                          [-0.95, 1.797],
                          [0.09, 2.045],
                          [7.285, 8.08],
                          [1.221, 0]
                        ],
                        "o": [
                          [-6.689, 5.535],
                          [0.398, 2.029],
                          [0.955, 1.807],
                          [6.813, -0.038],
                          [6.881, 0],
                          [2.187, 0.011],
                          [1.009, -1.907],
                          [-0.244, -5.532],
                          [-1.187, -1.317],
                          [-1.231, 0]
                        ],
                        "v": [
                          [-29.125, 11.353],
                          [-32.077, 32.689],
                          [-29.993, 35.819],
                          [-24.991, 37.996],
                          [-4.55, 37.982],
                          [16.092, 37.995],
                          [21.094, 35.802],
                          [23.144, 29.56],
                          [18.404, 11.321],
                          [-1.731, -58.452]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 65,
                    "s": [
                      {
                        "i": [
                          [0.95, -1.412],
                          [-0.3, -3.773],
                          [-0.587, -2.112],
                          [-1.644, -0.669],
                          [-5.035, 0.028],
                          [-4.164, 3.274],
                          [-0.607, 1.981],
                          [-0.063, 3.462],
                          [4.051, 7.403],
                          [1.221, 0]
                        ],
                        "o": [
                          [-2.974, 5.414],
                          [-0.288, 3.569],
                          [0.557, 1.909],
                          [3.53, 2.576],
                          [4.712, -0.019],
                          [1.674, -0.461],
                          [0.638, -2.012],
                          [0.315, -5.004],
                          [-0.709, -1.512],
                          [-1.231, 0]
                        ],
                        "v": [
                          [-19.543, -14.051],
                          [-21.686, 1.219],
                          [-20.13, 6.465],
                          [-16.588, 10.082],
                          [-4.744, 15.839],
                          [6.181, 11.509],
                          [10.847, 6.185],
                          [13.053, -0.75],
                          [9.816, -14.029],
                          [-4.229, -48.102]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 69,
                    "s": [
                      {
                        "i": [
                          [0.367, -1.763],
                          [0.534, -2.499],
                          [-0.031, -2.391],
                          [-0.922, -1.578],
                          [-2.665, 0.066],
                          [-1.094, 1.204],
                          [-0.15, 2.226],
                          [0.788, 1.889],
                          [0.196, 4.84],
                          [1.221, 0]
                        ],
                        "o": [
                          [-0.404, 1.945],
                          [-1.202, 5.621],
                          [0.026, 2.044],
                          [0.34, 0.582],
                          [1.821, -0.045],
                          [0.991, -1.09],
                          [0.145, -2.153],
                          [-0.83, -1.99],
                          [-0.072, -1.772],
                          [-1.231, 0]
                        ],
                        "v": [
                          [-6.766, -47.925],
                          [-7.831, -40.742],
                          [-9.888, -30.642],
                          [-8.874, -27.72],
                          [-4.416, -24.144],
                          [-0.343, -28.451],
                          [0.673, -32.14],
                          [-0.985, -39.131],
                          [-1.636, -47.828],
                          [-4.227, -51.233]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 4,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "gf",
              "o": { "a": 0, "k": 100, "ix": 10 },
              "r": 1,
              "bm": 0,
              "g": {
                "p": 3,
                "k": {
                  "a": 0,
                  "k": [
                    0.243, 0.149, 0.922, 0.639, 0.43, 0.075, 0.782, 0.802,
                    0.677, 0, 0.643, 0.965
                  ],
                  "ix": 9
                }
              },
              "s": { "a": 0, "k": [0.56, 223.083], "ix": 5 },
              "e": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 56,
                    "s": [-0.62, -270.102],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 69, "s": [-4.121, -60.832] }
                ],
                "ix": 6
              },
              "t": 1,
              "nm": "Gradient Fill 1",
              "mn": "ADBE Vector Graphic - G-Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [204.08, 133.594], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100.318, 100.4], "ix": 3 },
              "r": { "a": 0, "k": -0.031, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 76,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}
